export default __webpack_public_path__ + "static/media/russia.5a8a362b.png";